import queryString from 'query-string';
import { pathOr } from 'ramda';
import { match } from 'react-router-dom';

import GET_MERCHANT_VENUES_RESULTS from './scenes/MerchantStatusDetails/scenes/sections/MerchantVenues/sections/VenueSearchResults.queries';

type Search = {
  searchType?: string;
  filter?: string;
  searchText?: string;
  cnidsToFilter?: string;
};

const CSVFields = [
  {
    label: 'Store ID',
    value: 'locationId',
  },
  {
    label: 'Address',
    value: 'address1',
  },
  {
    label: 'City',
    value: 'city',
  },
  {
    label: 'State',
    value: 'state',
  },
  {
    label: 'Zip Code',
    value: 'postalCode',
  },
  {
    label: 'Total Transactions',
    value: 'totalTransactions',
  },
  {
    label: 'Status',
    value: 'status',
  },
  {
    label: 'Visa',
    value: 'transactingOnVisa',
  },
  {
    label: 'MasterCard',
    value: 'transactingOnMC',
  },
  {
    label: 'AMEX',
    value: 'transactingOnAmex',
  },
  {
    label: 'Visa Status',
    value: 'statusOfVisa',
  },
  {
    label: 'MasterCard Status',
    value: 'statusOfMC',
  },
  {
    label: 'AMEX Status',
    value: 'statusOfAmex',
  },
];

const CSVDiscoveredVenueFields = [
  {
    label: 'Name',
    value: 'name',
  },
  {
    label: 'Transactions',
    value: 'transactions',
  },
  {
    label: 'Address',
    value: 'address.address1',
    default: 'N/A',
  },
  {
    label: 'City',
    value: 'address.city',
    default: 'N/A',
  },
  {
    label: 'State',
    value: 'address.state',
    default: 'N/A',
  },
  {
    label: 'Zip Code',
    value: 'address.postal',
  },
  {
    label: 'CN',
    value: 'cardNetworkId.cardNetwork',
    default: 'N/A',
  },
  {
    label: 'CN EID',
    value: 'cardNetworkId.cardNetworkExternalId',
    default: 'N/A',
  },
  {
    label: 'CN Type',
    value: 'cardNetworkId.cardNetworkExternalIdType',
    default: 'N/A',
  },
];

const getBulkConfig = ({
  match,
  location,
  responseMapping,
}: {
  match: match;
  location: Location;
  responseMapping?: Function;
}) => {
  const {
    searchType = '',
    searchText,
    filter = '',
    cnidsToFilter,
  }: Search = queryString.parse(location.search);

  const offerNetworkExternalVenueId = pathOr(
    '',
    ['params', 'merchantId'],
    match,
  );

  return {
    responseMapping,
    queryName: 'searchMerchantVenues',
    query: GET_MERCHANT_VENUES_RESULTS,
    dataPath: ['searchMerchantVenues', 'result'],
    variables: {
      params: {
        offerNetworkExternalVenueId,
        pagingInput: {
          page: 1,
          pageSize: 3000,
        },
        [searchType]: searchText,
        [filter]: cnidsToFilter,
      },
    },
  };
};

export { CSVFields, getBulkConfig, CSVDiscoveredVenueFields };
